<!--Navbar-->
<nav id="top-nav" class="navbar navbar-expand-lg navbar-dark fixed-top scrolling-navbar">

    <div class="container">
        <!-- Navbar brand -->
        <span class="navbar-brand" translate>TITLE</span>

        <!-- Collapse button -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Collapsible content -->
        <div #collapsible class="collapse navbar-collapse" id="navbarSupportedContent">

            <!-- Links -->
            <ul class="navbar-nav mr-auto">


            </ul>
            <!-- Links -->

            <!-- Search form -->
            <!-- <form class="form-inline">
                <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search">
            </form> -->
            <ul class="navbar-nav">
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link btn btn-md my-0 btn-outline-white" routerLink="/in/decision">{{'ICHANGEDMYMIND' | translate}}</a>
                </li>
                <li class="nav-item dropdown">
                    <a data-toggle="dropdown" [class]="'nav-link dropdown-toggle '+ls.getFlag()" id="navbarDropdownMenuLink">{{ls.getLanguageName()}}</a>
                    <div class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="navbarDropdownMenuLink">
                        <ng-template ngFor let-lang [ngForOf]="ls.getLanguages()">
                            <a [class]="'dropdown-item waves-light '+ls.getFlag(lang.code)" (click)="ls.switchTo(lang.code)">{{lang.name}}</a>
                        </ng-template>
                    </div>
                </li>
                <li class="nav-item">
                    <a class="btn btn-outline-white btn-md my-0 py-2 waves-effect" (click)="onLogout()" *ngIf="showLogout | async" translate>USER.LOGOUT</a>
                </li>
            </ul>

        </div>
        <!-- Collapsible content -->
    </div>

</nav>
<!--/.Navbar-->


// WEBPACK FOOTER //
// ./src/app/components/top-nav/top-nav.component.html